import { EGoogleRedirectStatus } from 'constants/Google';
import React from 'react';
import StatusDisplayer from './StatusDisplayer';

const Error = () => {
  return <StatusDisplayer status={EGoogleRedirectStatus.ERROR} />;
};

export default Error;
